import { eventHasRun } from '../../utils/eventTracker';

export const DDC_LINK_CHAT_OPENED = 'ddc.link.chatOpened';
export default ({ currentTarget: element, timeStamp }) => {
	let eventObject;
	if (
		!eventHasRun(DDC_LINK_CHAT_OPENED, {
			timeStamp
		})
	) {
		eventObject = {
			eventType: DDC_LINK_CHAT_OPENED,
			eventData: {
				element
			}
		};
		const url = element.getAttribute('href');
		if (url) {
			eventObject.eventData.url = url;
		}
	}
	return eventObject;
};
